export enum ROLES {
  ADMIN = 'admin',
  MANAGER = 'manager',
  CLIENT = 'client',
  HEAD_MANAGER = 'head_manager',
  CLIENT_SUPPORT = 'client_support',
  DEVELOP = 'develop',
  CONSTRUCTOR_HANDLER = 'constructor_handler',
}
